import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { CommonFunctions } from '@shared/common-functions';
import { USER_ROLES } from '@shared/constant/shared.constant';
import { BookingSummary } from '@core/models/booking.model';
import { BookingService } from '@core/services/booking.service';
import { PaymentStatusForMessage } from '@core/models/api-response.model';
import { autoUnsubWith } from '@shared/services/utility.abstract';
import { EncryptionStorageService } from '@core/services/encryption-storage.service';

@Component({
  selector: 'app-view-booking',
  templateUrl: './view-booking.component.html',
  styleUrls: ['./view-booking.component.scss'],
})
export class ViewBookingComponent implements OnInit{
  readonly destroyRef = inject(DestroyRef);
  imagePath: string = '';
  bookingDetails: BookingSummary;
  arrival: Date;
  departure: Date;
  paymentStatus: number;
  paymentInfo: string;
  refundStatus: string;
  bookingType: string;
  role: string;

  constructor(
    public readonly ref: DynamicDialogRef,
    private readonly bookingService: BookingService,
    public readonly config: DynamicDialogConfig,
    private readonly encryptStorage: EncryptionStorageService
  ) {}

  ngOnInit(): void {
    this.role = this.encryptStorage.getItem('roleName');
    this.getBookingDetailById();
    this.refundStatus = this.config.data.refundStatus;
    this.paymentInfo = this.config.data?.description || '';
    this.bookingType = this.config.data?.bookingType;
  }

  getBookingDetailById(): void {
    
    const method =
      this.role === USER_ROLES.GROUP_USER
        ? 'getGroupBookingDetailById'
        : 'getBookingDetailById';
    this.bookingService[method](this.config.data.bookingId).pipe(autoUnsubWith(this.destroyRef)).subscribe({
      next: (response: any) => {
        const bookingResponse = response as BookingSummary;
        this.bookingDetails = bookingResponse;
        this.bookingDetails = response;
        
        this.arrival = response.arrivalTime ? new Date(response.arrivalTime.replace(' -', '')) : null;
        this.departure = response.departureTime ? new Date(response.departureTime.replace(' -', '')) : null;
        this.paymentStatus = response.paymentStatus;
      },
    });
  }

  cancelDialog(): void {
    this.ref.close();
  }
  closeSummaryModalOnOutSideClick(): void {
    if (this.ref && this.bookingDetails) {
      this.cancelDialog();
    }
  }

  getStatusImage(paymentStatus: number): string {
    switch (paymentStatus) {
      case 2:
        return 'assets/images/check-svg.svg';
      case 4:
        return 'assets/images/in-process.svg';
      case 5:
        return 'assets/images/failed.svg';
      case 1:
      case 3:
      case 6:
      case 8:
      case 10:
        return 'assets/images/pending-icon.svg';
      case 11:
        return 'assets/images/scheduled-icon.svg';
      case 9:
        return 'assets/images/cancelled-icon.svg';
      case 13:
      case 14:
      case 15:
      case 16:
        return 'assets/images/disputed-icon.svg';
      default:
        return '';
    }
  }

  openGatePass(bookingDetails): string {
    return CommonFunctions.openGatePass(this.bookingType, bookingDetails);
  }
  openTruckCheckOutUrl(event: MouseEvent, url: string) {
    event.preventDefault();
    window.open(`${url}`, '_blank');
  }

    shouldShowDisputeMessage(paymentStatus: number): boolean {
      return [
        PaymentStatusForMessage.DisputeCreated,
        PaymentStatusForMessage.DisputeUpdated,
        PaymentStatusForMessage.DisputeLoss,
        PaymentStatusForMessage.DisputeExpired
      ].includes(paymentStatus);
    }
  
}
